export default class PrintOS {
  constructor() {
    Object.keys(window.$printos).forEach(key => {
      this[key] = window.$printos[key];
    });
  }

}
